import type { SVGProps } from 'react'
const SvgSyTechSolidGift = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g fillRule="evenodd">
			<path
				fillOpacity={0.24}
				d="M6.8 6.8C3.9 6.8 3.6 3 6.8 3c2.3 0 3.3.7 5.2 1.5 2.1-.8 2.9-1.5 5.2-1.5 3.2 0 2.9 3.8 0 3.8z"
			/>
			<path
				fill="#e9e9e9"
				d="M20.2 12.8h-7.4V21h6c.8 0 1.5-.7 1.5-1.5v-6.7zm-16.4 0h7.5V21h-6c-.8 0-1.5-.7-1.5-1.5zm7.4-.8V6.8H3.8c-.8 0-1.5.7-1.5 1.5V12zm10.6 0h-9V6.8h7.5c.8 0 1.5.7 1.5 1.5z"
			/>
			<path d="M3.8 12h7.5v1.5H3.8zm9 0h7.5v1.5h-7.5z" />
			<path d="M13.5 6.8h.8V21h-.8zm-3 0h3V21h-3z" />
		</g>
	</svg>
)
export default SvgSyTechSolidGift
